// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.manage-header-container {
  text-align: start;
  margin-left: 26px;
}
.manage-header-container h4 {
  font-weight: 700;
  color: #444343;
}

.select-label {
  font-weight: 500;
}
.select-label div {
  margin-bottom: 4px;
}

.grade-container {
  border-radius: 4px;
  background-color: #EDf0F1;
  border: 1px solid #D1D3D4;
  margin-top: 20px;
  padding: 32px;
}

.plo-checkbox {
  margin-right: 12px;
}

.grade-name {
  color: #0669B3;
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 16px;
}

.standard-name {
  font-weight: 600;
  margin-left: 24px;
}

.grades-wrapper {
  margin-top: 24px;
}
.grades-wrapper .select-grade-label {
  font-weight: 500;
  margin-bottom: 8px;
}

.grade-btn-container {
  margin-top: 8px;
  flex-wrap: wrap;
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.content-status-on-grade-button {
  position: relative;
  bottom: 54px;
  left: 70px;
}

.selection-container {
  border-radius: 4px;
  background-color: rgba(192, 222, 240, 0.5);
  border: 1px solid #c0def0;
  padding: 24px;
  margin: 16px auto;
  width: 95%;
}

.outcomes-container {
  width: 95%;
  margin: auto;
}

.content-title {
  margin-bottom: 0px;
}

.selectable-input-wrapper {
  align-items: center;
  display: flex;
}
.selectable-input-wrapper input {
  transform: scale(1.3);
}

.reportable-content-wrapper {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  line-height: 1.5;
}

.reportable-content-wrapper-accordion {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  justify-content: space-between;
  width: 100%;
}
.reportable-content-wrapper-accordion :focus {
  background-color: #CFE2FF;
}

.rc-accordion-body {
  line-height: 1.5;
}

.rc-accordion-title {
  display: flex;
  width: 100%;
}
.rc-accordion-title input {
  margin: 0px 4px 0px 0px;
}

.epr-save-btn {
  width: 95%;
  margin: 12px auto;
  display: flex;
  justify-content: flex-end;
}

.number-circle {
  position: relative;
  bottom: 54px;
  left: 70px;
  background: white;
  border: 1px solid #444343;
  border-radius: 50%;
  color: #444343;
  height: 24px;
  padding: 4px;
  width: 24px;
}
.number-circle .count-in-circle {
  align-items: center;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  height: 100%;
  justify-content: center;
}

.missing {
  color: #CB321A;
  border: 2px solid #CB321A;
}

.selectable-content-label {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-right: 16px;
  width: 100%;
}

.read-selected-header-label {
  border-radius: 8px;
  background-color: rgba(192, 222, 240, 0.3);
  padding: 4px 0px;
}

.read-selected-child-label {
  border-radius: 8px;
  align-items: flex-start;
  background-color: rgba(192, 222, 240, 0.3);
  display: flex;
  padding: 4px 8px;
}

.selectable-child-label {
  align-items: flex-start;
  display: flex;
  padding: 4px 8px;
}

.content-area-select {
  border-radius: 5px;
  border: 1px solid #808080;
  color: #444343;
  padding: 5px;
}

.square-wrapper {
  min-height: 25px;
  min-width: 25px;
}

.italic {
  font-style: italic;
}

.active-check-input {
  margin-right: 8px;
  margin-top: 6px;
  transform: scale(1.2);
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ManageEprContent.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,iBAAA;EACA,iBAAA;AAUJ;AATI;EACI,gBAAA;EACA,cDuBC;ACZT;;AAPA;EACK,gBAAA;AAUL;AATK;EACG,kBAAA;AAWR;;AAPA;EChBI,kBDiBsB;EACtB,yBDII;ECHJ,yBAAA;EACA,gBAAA;EACA,aAAA;AAUJ;;AAPA;EACI,kBAAA;AAUJ;;AAPA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAUJ;;AAPA;EACI,gBAAA;EACA,iBAAA;AAUJ;;AARA;EACI,gBAAA;AAWJ;AATG;EACK,gBAAA;EACA,kBAAA;AAWR;;AANA;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;AASJ;;AANA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AASJ;;AANA;EC/DI,kBDgEsB;EACtB,0CAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;AASJ;;AANA;EACI,UAAA;EACA,YAAA;AASJ;;AANA;EACI,kBAAA;AASJ;;AANA;EACI,mBAAA;EACA,aAAA;AASJ;AARI;EACI,qBAAA;AAUR;;AANA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AASJ;;AANA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;AASJ;AARI;EACI,yBAAA;AAUR;;AANA;EACI,gBAAA;AASJ;;AANA;EACI,aAAA;EACA,WAAA;AASJ;AARI;EACI,uBAAA;AAUR;;AANA;EACI,UAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;AASJ;;AANA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EAEA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cD1GK;EC2GL,YAAA;EACA,YAAA;EACA,WAAA;AAQJ;AANI;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;AAQR;;AAJA;EACI,cDvIE;ECwIF,yBAAA;AAOJ;;AAJA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;AAOJ;;AALA;ECjKI,kBDkKsB;EACtB,0CAAA;EACA,gBAAA;AAQJ;;AALA;ECvKI,kBDwKsB;EACtB,uBAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;AAQJ;;AALA;EACI,uBAAA;EACA,aAAA;EACA,gBAAA;AAQJ;;AALA;ECrLI,kBDsLsB;EACtB,yBAAA;EACA,cD5JK;EC6JL,YAAA;AAQJ;;AALA;EACI,gBAAA;EACA,eAAA;AAQJ;;AALA;EACI,kBAAA;AAQJ;;AALA;EACI,iBAAA;EACA,eAAA;EACA,qBAAA;AAQJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.manage-header-container{\n    text-align: start;\n    margin-left: 26px;\n    h4 {\n        font-weight: 700;\n        color: $grey4a;\n    }\n}\n\n.select-label {\n     font-weight: 500;\n     div {\n        margin-bottom: 4px;\n     }\n}\n\n.grade-container {\n    @include borderRadius(4px);\n    background-color: $grey0;\n    border: 1px solid $grey1;\n    margin-top: 20px;\n    padding: 32px;\n}\n\n.plo-checkbox {\n    margin-right: 12px;\n}\n\n.grade-name {\n    color: $pearl-blue;\n    font-weight: 600;\n    font-size: 24px;\n    margin-bottom: 16px;\n}\n\n.standard-name {\n    font-weight: 600;\n    margin-left: 24px;\n}\n.grades-wrapper {\n    margin-top: 24px;\n\n   .select-grade-label {\n        font-weight: 500;\n        margin-bottom: 8px;\n    }\n\n}\n\n.grade-btn-container {\n    margin-top: 8px;\n    flex-wrap: wrap;\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n}\n\n.content-status-on-grade-button {\n    position: relative;\n    bottom: 54px;\n    left: 70px;\n}\n\n.selection-container {\n    @include borderRadius(4px);\n    background-color: rgba(192, 222, 240, 0.5);\n    border: 1px solid $pale-blue;\n    padding: 24px;\n    margin: 16px auto;\n    width: 95%\n}\n\n.outcomes-container {\n    width: 95%;\n    margin: auto;\n}\n\n.content-title {\n    margin-bottom: 0px;\n}\n\n.selectable-input-wrapper {\n    align-items: center;\n    display: flex;\n    input {\n        transform: scale(1.3);\n    }\n}\n\n.reportable-content-wrapper {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 8px;\n    line-height: 1.5;\n}\n\n.reportable-content-wrapper-accordion {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 8px;\n    justify-content: space-between;\n    width: 100%;\n    :focus {\n        background-color: #CFE2FF;\n    }\n}\n\n.rc-accordion-body {\n    line-height: 1.5;\n}\n\n.rc-accordion-title {\n    display: flex;\n    width: 100%;\n    input {\n        margin: 0px 4px 0px 0px;\n    }\n}\n\n.epr-save-btn {\n    width: 95%;\n    margin: 12px auto;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.number-circle {\n    position: relative;\n    bottom: 54px;\n    left: 70px;\n\n    background: white;\n    border: 1px solid $grey4a;\n    border-radius: 50%;\n    color: $grey4a;\n    height: 24px;\n    padding: 4px;\n    width: 24px;\n\n    .count-in-circle {\n        align-items: center;\n        display: flex;\n        font-size: 14px;\n        font-weight: 500;\n        height: 100%;\n        justify-content: center;\n    }\n}\n\n.missing {\n    color: $red;\n    border: 2px solid $red;\n}\n\n.selectable-content-label {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-right: 16px;\n    width: 100%;\n}\n.read-selected-header-label {\n    @include borderRadius(8px);\n    background-color: rgba(192,222,240,0.3);\n    padding: 4px 0px;\n}\n\n.read-selected-child-label {\n    @include borderRadius(8px);\n    align-items: flex-start;\n    background-color: rgba(192, 222, 240, 0.3);\n    display: flex;\n    padding: 4px 8px;\n}\n\n.selectable-child-label {\n    align-items: flex-start;\n    display: flex;\n    padding: 4px 8px;\n}\n\n.content-area-select {\n    @include borderRadius(5px);\n    border: 1px solid $grey3;\n    color: $grey4a;\n    padding: 5px;\n}\n\n.square-wrapper {\n    min-height: 25px;\n    min-width: 25px;\n}\n\n.italic {\n    font-style: italic;\n}\n\n.active-check-input {\n    margin-right: 8px;\n    margin-top: 6px;\n    transform: scale(1.2);\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
